import { Injectable, signal, inject, RendererFactory2, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Injectable()
export class MenuService {
  private router = inject(Router);
  private renderer = inject(RendererFactory2).createRenderer(null, null);
  private platformId = inject(PLATFORM_ID);

  isOpen = signal(false);

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.close();
    });
  }

  toggle() {
    this.isOpen.update((val) => !val);
    this.updateBodyScroll(this.isOpen());
  }

  close() {
    if (this.isOpen()) {
      this.isOpen.set(false);
      this.updateBodyScroll(false);
    }
  }

  private updateBodyScroll(disable: boolean) {
    if (isPlatformBrowser(this.platformId)) {
      if (disable) {
        this.renderer.addClass(document.body, 'no-scroll');
      } else {
        this.renderer.removeClass(document.body, 'no-scroll');
      }
    }
  }
}
